// components/PeriodSwitcher.js

import React from 'react';
import { ButtonGroup, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

const PeriodSwitcher = ({ selectedPeriod, onPeriodChange, periodInfo }) => {
  const periods = [
    { 
      key: 'current-week', 
      label: 'Current Week',
      tooltip: 'This week\'s transactions'
    },
    { 
      key: 'current-fortnight', 
      label: 'Current Fortnight',
      tooltip: 'Based on the fortnightStartDate managed in settings - same as the transfer table'
    },
    { 
      key: 'two-weeks', 
      label: 'Two Weeks',
      tooltip: 'Two weeks from and including the current week'
    },
    { 
      key: 'three-weeks', 
      label: 'Three Weeks',
      tooltip: 'Three weeks from and including the current week'
    },
    { 
      key: 'four-weeks', 
      label: 'Four Weeks',
      tooltip: 'Four weeks from and including the current week'
    }
  ];

  const renderTooltip = (tooltip) => (
    <Tooltip id="period-tooltip">{tooltip}</Tooltip>
  );

  return (
    <div className="mb-3">
      <ButtonGroup size="sm" className="w-100">
        {periods.map(period => (
          <OverlayTrigger
            key={period.key}
            placement="top"
            overlay={renderTooltip(period.tooltip)}
          >
            <Button
              variant={selectedPeriod === period.key ? "primary" : "outline-primary"}
              onClick={() => onPeriodChange(period.key)}
              style={{
                fontSize: '12px',
                padding: '0.25rem 0.5rem',
                backgroundColor: selectedPeriod === period.key ? '#A0C2BB' : 'transparent',
                borderColor: '#A0C2BB',
                color: selectedPeriod === period.key ? 'white' : '#A0C2BB',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                if (selectedPeriod !== period.key) {
                  e.target.style.backgroundColor = '#A0C2BB';
                  e.target.style.color = 'white';
                }
              }}
              onMouseLeave={(e) => {
                if (selectedPeriod !== period.key) {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#A0C2BB';
                }
              }}
            >
              {period.label}
            </Button>
          </OverlayTrigger>
        ))}
      </ButtonGroup>
    </div>
  );
};

export default PeriodSwitcher;
